<template>
    <div class="leave chat_pc">
        <div class="header" :style="cssVars">
            <div class="tabs" @click="chooseType('create')" :class="active === 'create' ? 'active' : ''">
                {{ $t("message") }}
            </div>
            <div class="tabs" @click="chooseType('list')" :class="active === 'list' ? 'active' : ''">
                {{ $t("leaveHis") }}
            </div>
            <i class="el-icon-close back" @click="back"></i>
        </div>
        <div v-if="active === 'create'" class="modal_body scroll_bar">
            <div class="top-tip-txt">
                <p>
                    {{ $t("txbj") }}
                </p>
            </div>
            <div>
                <div class="form_item">
                    <div>
                        <span class="red">*</span>
                        <span>{{ $t('userName') }}</span>
                    </div>
                    <el-input v-model="customerName" type="text" :placeholder="$t('input')"/>
                </div>
                <div class="form_item">
                    <div>
                        <span>{{ $t('userPhone') }}</span>
                    </div>
                    <el-input v-model="customerPhone" type="text" :placeholder="$t('input')"/>
                </div>
                <div class="form_item">
                    <div>
                        <span>{{ $t('userEmail') }}</span>
                    </div>
                    <el-input v-model="customerEmail" type="text" :placeholder="$t('input')"/>
                </div>
                <div class="form_item">
                    <div>
                        <span class="red">*</span>
                        <span>{{ $t('leaveMsgCon') }}</span>
                    </div>
                    <el-input type="textarea" :autosize="{ minRows: 5, maxRows: 5 }" v-model="msgContent"
                              :placeholder="$t('pleInput')"/>
                </div>

            </div>
        </div>
        <div class="bottomBtn" v-if="active === 'create'">
            <el-button :style="{ background: `linear-gradient(to right, ${initData.mainColor})` }" class="submitBtn"
                       type="primary" @click="sendMessage">
                {{ $t("submitLeave") }}
            </el-button>
        </div>

        <div v-if="active === 'list'" class="modal_body scroll_bar">
            <div >
                <div class="leave_msg_item" v-for="item in leavelist">
                    <div>
                        <span class="label">{{ $t('messageName') }}：</span>
                        <span>{{ item.customerName }}</span>
                    </div>
                    <div>
                        <span class="label">{{ $t('messageEmail') }}：</span>
                        <span>{{ item.customerEmail }}</span>
                    </div>
                    <div>
                        <span class="label">{{ $t('messagePhone') }}：</span>
                        <span>{{ item.customerPhone }}</span>
                    </div>
                    <div>
                        <span class="label">{{ $t('messageContent') }}：</span>
                        <span>{{ item.msgContent }}</span>
                    </div>
                    <div>
                        <span class="label">{{ $t('messageSubmitTime') }}：</span>
                        <span>{{ formDate(item.createTime) }}</span>
                    </div>
                    <div>
                        <span class="label">{{ $t('messageStatus') }}：</span>
                        <span>{{ item.msgState == 1 ? $t('haveDeal') : $t('noDeal') }}</span>
                    </div>
                    <div v-if="item.updateTime">
                        <span class="label">{{ $t('messageDealTime') }}：</span>
                        <span>{{ formDate(item.updateTime) }}</span>
                    </div>
                    <!--                    <div v-if="item.updateUserName">-->
                    <!--                        <span class="label">处理时间：</span>-->
                    <!--                        <span>{{ formDate(item.updateUserName) }}</span>-->
                    <!--                    </div>-->
                </div>
            </div>
        </div>

        <el-drawer :append-to-body="true" :modal-append-to-body="false" :transfer="false" class="drawer" size="100%"
                   direction="rtl" :title="$t('leaveMsg')" :visible.sync="showFlag">
            <div class="card-content scroll_bar" id="iii">
                <v-loading v-if="hide"></v-loading>
                <div class="detailTime-style">
                    <el-timeline>
                        <el-timeline-item size="large" class="fir"><br/></el-timeline-item>
                        <el-timeline-item v-for="(item, index) in orderDetail.handle" :key="index" :icon="item.icon"
                                          :type="item.type" :size="item.size">
                            <div class="companydel">
                                <span class="time sub sub_title">{{ formDate(item.handleTime) }}</span>
                            </div>
                            <div class="contentdel">
                                <div class="pannel">
                  <span v-if="item.handleUserName" class="name sub">{{
                          item.handleUserName == "customer" ? $t("client") : $t("customer")
                      }}</span>
                                    <span v-if="!item.handleUserName" class="name sub">{{
                                            $t("client")
                                        }}</span>
                                </div>
                                <div class="pannel">
                                    <span class="titl">{{ $t("orderStatus") }}:</span>
                                    <span> {{ workOrderStateList[item.handleWoStatus] }}</span>
                                </div>
                                <div class="pannel">
                                    <span class="titl fl">{{ $t("reply") }}:</span>
                                    <span class="qp" v-html="item.handleContent"></span>
                                </div>

                                <div class="pannel" v-if="item.woFileVoList && item.woFileVoList.length > 0">
                                    <span class="titl fl">{{ $t("attachments") }}:</span>
                                    <span v-for="(it, index) in item.woFileVoList" :key="index">
                    <a class="link" target="_blank" :href="it.fileUrl">{{ it.fileName }}
                    </a>
                  </span>
                                </div>
                            </div>
                        </el-timeline-item>
                    </el-timeline>
                </div>
            </div>

            <div class="bottomBtn">
                <el-button :style="{ background: `linear-gradient(to right, ${initData.mainColor})` }" class="submitBtn"
                           type="primary" @click="showReply = true">
                    {{ $t("reply") }}
                </el-button>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import {Toast} from "mint-ui";
import store from "../../store/index";

import urlParams from "../../api/urlParams";
import request from "../../api/request";

import chatApi from "../methods";

export default {
    name: "pc",
    data() {
        return {
            active: "create",
            fileList: [],
            email: "",
            loadStatus: false,
            showReply: false,
            hide: false,
            LeaveMsgF: false,
            list: [],
            extendsField: [],
            Field: [],
            chooseList: [],

            optionProps2: {
                value: "id",
                label: "name",
                children: "children",
            },
            showFlag: false,
            orderDetail: {},
            levelLists: {
                0: this.$t("orderLow"),
                1: this.$t("orderNormal"),
                2: this.$t("orderWarning"),
                3: this.$t("orderDanger"),
            },
            workOrderStateList: {
                99: this.$t("orderOver"),
                0: this.$t("orderNoYet"),
                1: this.$t("orderAccept"),
                2: this.$t("orderWait"),
                3: this.$t("orderResolved"),
                5: this.$t("orderOver"),
            },
            typeId: "",
            typeName: "",
            mainColor: '',
            cusColor: '',
            sideShow: false,
            msgContent: '',
            customerEmail: '',
            customerName: '',
            customerPhone: '',
            leavelist: []
        };
    },
    watch: {
        initData() {
            return this.$store.state.initData;
        },
        connectStatus() {
            return this.$store.state.connectStatus
        }
    },
    computed: {
        initData() {
            this.mainColor = this.$store.state.initData.mainColor;
            this.cusColor = this.$store.state.initData.cusColor;
            if (this.$store.state.initData.sideBarStatus && this.$store.state.initData.sideBarList.length > 0) {
                this.sideShow = true;
            }
            return this.$store.state.initData;
        },
        customer() {
            return this.$store.state.customer;
        },
        connectStatus() {
            return this.$store.state.connectStatus
        },
        cssVars() {
            return {
                "--cusColor": this.cusColor
            };
        }

    },

    mounted() {
    },
    methods: {
        formDate(value, fmt) {
            if (!value) {
                return "--";
            }
            fmt = fmt || "yyyy-MM-dd hh:mm:ss";
            if (value && value < 10000000000) {
                value = value * 1000;
            }

            let getDate = new Date(value * 1);
            let o = {
                "M+": getDate.getMonth() + 1,
                "d+": getDate.getDate(),
                "h+": getDate.getHours(),
                "m+": getDate.getMinutes(),
                "s+": getDate.getSeconds(),
                "q+": Math.floor((getDate.getMonth() + 3) / 3),
                S: getDate.getMilliseconds(),
            };
            if (/(y+)/.test(fmt)) {
                fmt = fmt.replace(
                    RegExp.$1,
                    (getDate.getFullYear() + "").substr(4 - RegExp.$1.length)
                );
            }
            for (let k in o) {
                if (new RegExp("(" + k + ")").test(fmt)) {
                    fmt = fmt.replace(
                        RegExp.$1,
                        RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
                    );
                }
            }
            return fmt;
        },
        chooseType(type) {
            this.active = type;
            this.showFlag = false;
            this.msgContent = [];
            this.fileList = [];
            this.activeType = type;
            if (type === "list") {
                this.getLeaveMsg();
            }
        },
        back() {
            this.$router.push(
                "/index" + "?channelId=" + this.$route.query.channelId
            );
        },
        getLeaveMsg() {
            this.msgContent = [];
            this.fileList = [];
            chatApi.getLeaveMsg((result) => {
                this.leavelist = result.data;
            })
        },

        showDetail(item) {
            this.showFlag = true;
            request
                .woinfo({
                    id: item.woId,
                })
                .then((res) => {
                    console.log(res);
                    this.orderDetail = res.data;
                });
        },
        getRes(res) {
            console.log(res);
        },
        changeFile(file, fileList) {
            console.log(fileList);
            this.fileList = fileList;
        },
        handlevwove(file, fileList) {
            console.log(fileList);
            this.fileList = fileList;
        },
        handlePreview(file) {
            console.log(file);
        },
        checkFileExist(file, fileList) {
            console.log(file);
            const files = file; //获取文件
            let Arr = [
                ".rar",
                ".zip",
                ".tar",
                ".gz",
                ".7z",
                ".bz2",
                ".cab",
                ".iso",
                ".doc",
                ".docx",
                ".xls",
                ".xlsx",
                ".ppt",
                ".pptx",
                ".pdf",
                ".txt",
                ".md",
                ".xml",
                ".txt",
            ];
            let fileName = files.name;
            let fileIndex = fileName.lastIndexOf(".");
            let substrName = fileName.substr(fileIndex);
            if (Arr.indexOf(substrName) > -1) {
                this.$message({
                    type: "error",
                    message: this.$t("onlyIMG"),
                });
                file.target.value = null;
                return;
            }
            if (file.size > 5242880 * 10) {
                Message({
                    message: window.vm.$i18n.t("fileMax"),
                    type: "error",
                });
                return;
            }
            const obj = {
                file: files,
                userId: store.state.userInfo.userId || urlParams("userId"),
            };
            this.fileList = [];
            request.uploadFile(obj).then((result) => {
                if (result.code === 200) {
                    console.log(result, "fj");
                    this.fileList.push(result.data);
                }
            });
        },

        beforevwove(file, fileList) {
            return this.$confirm("delete" + ` ${file.name}？`);
        },
        // 发送留言
        sendMessage() {
            var param = {
                "customerEmail": this.customerEmail,
                "customerName": this.customerName,
                "customerPhone": this.customerPhone,
                "msgContent": this.msgContent,
                channelId: this.initData.channelId,
            }
            chatApi.submitMessage(param, () => {
                this.customerEmail = '';
                this.customerName = '';
                this.customerPhone = '';
                this.msgContent = '';
                store.dispatch('setConfigPc', [{key: 'showModal', value: false}, {
                    key: 'messageModal',
                    value: false
                }])
            })

        },
    },
};
</script>

<style scoped>
.chat_pc {
    height: 626px;
    max-width: 900px;
    min-width: 640px;
    width: 640px;
    display: flex;
    flex-direction: column;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    margin: auto;
    box-shadow: 0 4px 16px 0 rgba(81, 90, 124, 0.15);
}

.drawer {
    height: 626px;
    display: flex;
    flex-direction: column;
    position: absolute;
    max-width: 900px;
    min-width: 640px;
    width: 640px;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    margin: auto;
    box-shadow: 0 4px 16px 0 rgb(81 90 124 / 15%);
}

.dialog {
    height: 626px;
    display: flex;
    flex-direction: column;
    position: absolute;
    max-width: 900px;
    min-width: 640px;
    width: 640px;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    margin: auto;
    box-shadow: 0 4px 16px 0 rgba(81, 90, 124, .15);
    border-radius: 5px;
}

.leave {
    /* width: 60%;
    height: 98%; */
    /* border: 1px solid #efebeb;
    margin: 0 auto; */
}

.header {
    display: flex;
    font-size: 14px;
    margin: 0 auto;
    width: 300px;
    height: 60px;
}

.header > div {
    flex: 1;
    line-height: 47px;
    padding: 10px;
    margin: 0 20px;
    cursor: pointer;

    font-size: 15px;
    font-weight: 700;
}

.tabs.active {
    color: var(--cusColor);
    border-bottom: 3px solid var(--cusColor);
}

.main {
    padding: 35px;
}

.tips {
    color: #727272;
    font-size: 13px;
    text-align: left;
}

strong {
    color: red;
}

.items {
    text-align: left;
}

.items .label {
    font-size: 14px;
    color: #5a5a5a;
    line-height: 45px;
}

.modal_body {
    padding: 30px 10px 80px 15px;
    flex: 1;
    height: 500px;
    max-height: 500px;
}

.modal_body > p {
    margin-top: 0;
    font-size: 14px;
}

.form_item > div {
    display: block;
    /* width: 80px; */
    vertical-align: middle;
    color: #666666;
}

.form_item {
    display: block;
    align-items: center;
    margin: 15px auto;
    width: 80%;
    text-align: left;
}

.label {
    margin-bottom: 10px;
}

.form_item .el-input,
.form_item .el-textarea {
    flex: 1;
    font-size: 14px;
    vertical-align: middle;
    color: #535151;
    outline: none;
}

textarea {
    flex: 1;
    resize: none;
    height: 42px;
    width: 440px;
    vertical-align: text-top;
    padding: 8px;
    border: 1px solid #e6e6e6;
    outline: none;
    color: #535151;
}

button {
    width: 180px;
    height: 32px;
    color: white;
    border-radius: 4px;
    cursor: pointer;
    border: none;
}

.uploadBtn {
    width: 80px;
    height: 27px;
    color: #66b1ff;
    border-radius: 4px;
    cursor: pointer;
    border: none;
    margin: 0;
    text-align: left;
}

div.row {
    width: 100%;
    max-width: 410px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
}

.row .item {
    flex: 1;
    margin: 10px 5px;
    border-radius: 4px;
    cursor: pointer;
}

.row .item.active {
    color: white;
    border: none;
}

.noData {
    height: 20px;
}

button {
    margin-top: 20px;
}

.manual {
    min-height: 200px;
}

.manual .star {
    display: inline-block;
    width: 50px;
    height: 50px;
    background-image: url("../../../static/image/star.png");
    background-size: 100% 100%;
    cursor: pointer;
}

.manual .star.active {
    background-image: url("../../../static/image/starActive.png");
}

.manual p {
    font-size: 14px;
    color: #7467f0;
    margin: 15px;
}

.leave_msg_item {
    padding: 20px 14px;
    border: 1px solid #f0f1f2;
    cursor: pointer;
    border-radius: 3px;
    background: #fff;
    width: 80%;
    margin: 10px auto;
}

.leave_msg_item:hover {
    border: 1px solid #f7f9fc;
    background-color: #f7f9fc;
}

.leave_msg_item div {
    text-align: left;
    font-size: 12px;
    line-height: 18px;
    margin: 8px 0;
    color: #a1a7b3;
}

.leave_msg_item .label {
    width: 105px;
    display: inline-block;
    text-align: right;
    padding-left: 3px;
    color: #666;
}

.leave_msg_item .time {
    width: 216px;
    display: inline-block;
    text-align: left;
    color: #3d424d;
    font-weight: 600;
}

.leave_msg_item .woStatus {
    float: right;
    display: block;
    color: #fff;
    width: 80px;
    text-align: center;
    border-radius: 3px;
    background: #e4eaf2;
}

.leave_msg_item .label + span {
    width: 60px;
}

.file {
    width: 70px;
    position: relative;
}

.file a {
    position: absolute;
    left: 26px;
    line-height: 26px;
    color: #fff;
}

.file input {
    opacity: 0;
}

.el-steps--vertical {
    height: auto;
}

.top-tip-txt {
    margin: 6px auto 16px;
    font-size: 12px;
    font-weight: 300;
    color: #a1a7b3;
    width: 80%;
    text-align: left;
}

.top-tip-txt p {
    margin-bottom: 0;
    word-break: break-word;
}

.h300 {
    overflow-y: scroll;
    height: 300px;
}

.bottomBtn {
    position: absolute;
    bottom: 0;
    z-index: 1;
    width: 100%;
    text-align: center;
    background: #f5f9fa;
}

.submitBtn {
    display: inline-block;
    height: 36px;
    margin: 11px 0;
    border-radius: 2px;
    text-align: center;
    color: #fff;
    border: 1px solid var(--theme-color);
    background: var(--theme-color);
    cursor: pointer;
}

.card-content .detailTime-style {
    position: absolute;
    left: 10px;
    top: 5px;
    height: 300px;
}

.el-timeline .fir .el-timeline-item__node {
    background-color: white;
    border: 1px #e4e7f0 solid;
}

.el-timeline .las .el-timeline-item__node {
    background-color: white;
    border: 1px #e4e7f0 solid;
}

.companydel {
    color: #6f6f6f;
    position: absolute;
    width: 100px;
    font-size: 12px;
    left: -100px;
}

.contentdel {
    position: relative;
    padding: 10px;
    top: -10px;
    border: 1px solid #e4e7f0;
    border-radius: 8px;
    font-size: 12px;
    color: #6f6f6f;
}

.statusfalse {
    background-color: #3d87f2;
    text-align: center;
    color: #fff;
    border-radius: 6px;
    padding: 2px 5px;
}

.statustrue {
    background-color: #dc4e47;
    text-align: center;
    color: #fff;
    border-radius: 6px;
    padding: 2px 5px;
}

.contentdel::before {
    position: absolute;
    top: 34px;
    left: -10px;
    top: 15px;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-right: 10px solid #e4e7f0;
    content: "";
}

.fr {
    float: right;
}

.contentdel::after {
    position: absolute;
    top: 34px;
    left: -8px;
    top: 15px;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-right: 10px solid #fff;
    content: "";
}

.card-content .loadmore-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f8f8f8;
    padding: 20px 0;
}

.card-content .load-style {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: rgba(#000, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
}

.card-content .nodata-con {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.card-content {
    height: 100%;
    overflow: auto;
    position: relative;
}

.el-timeline {
    margin-left: 100px;
}

.pannel {
    max-width: 400px;
}

.back {
    position: absolute;
    right: 20px;
    cursor: pointer;
    line-height: 60px;
}

.yellow {
    background: #fff8e6 !important;
    border-color: #fff1cc;
    color: #ffba00 !important;
}

.green {
    background: #e7faf0 !important;
    border-color: #d0f5e0;
    color: #13ce66 !important;
}

.blue {
    background: #ebf2ff !important;
    border-color: #d6e5ff;
    color: #347dff !important;
}

.redFont {
    background-color: #ffeded !important;
    border-color: #ffdbdb;
    color: #ff4949 !important;
}

.link {
    display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/leaveMsg/pc.vue